/**
 * Cursor paginado y lightbox de la galeria de la ficha de producto.
 *
 * Antes hablaba con slick, que traia woo-variation-gallery. Ahora el carrusel lo mueve Swiper
 * (ui/product-gallery.js) y aqui solo cambia de quien se pide el indice y a quien se le dice
 * que pase de imagen; el marcado y las clases son los mismos, asi que el CSS no se toca.
 *
 * La instancia de Swiper vive en .woo-variation-gallery-slider-wrapper, que es el contenedor;
 * .woo-variation-gallery-slider es su .swiper-wrapper interno.
 */

(function () {
  const WRAPPER = '.woo-variation-gallery-wrapper';
  const CONTENEDOR = '.woo-variation-gallery-slider-wrapper';
  const EXCLUDE = '.is-art';

  let isClicking = false;
  let observer = null;

  const cursor = document.createElement('div');
  cursor.id = 'wvg-custom-cursor';
  cursor.innerHTML = `
    <div class="wvg-cursor-pagination">
      <span class="sc-paginated-cursor__prev">
        <i class="w-5 h-5 stroke-[1.4]" data-lucide="arrow-left"></i>
      </span>
      <span class="sc-paginated-cursor__label"></span>
      <span class="sc-paginated-cursor__next">
        <i class="w-5 h-5 stroke-[1.4]" data-lucide="arrow-right"></i>
      </span>
    </div>
  `;
  document.body.appendChild(cursor);

  const label = cursor.querySelector('.sc-paginated-cursor__label');

  // Inicializar iconos Lucide si están disponibles
  if (window.lucide) window.lucide.createIcons();

  function ensureOnTop() {
    if (document.body.lastElementChild !== cursor) {
      document.body.appendChild(cursor);
      if (window.lucide) window.lucide.createIcons();
    }
  }

  function getSwiper(wrapper) {
    return wrapper.querySelector(CONTENEDOR)?.swiper ?? null;
  }

  function updatePagination(swiper) {
    const total = swiper.slides.length;
    const current = swiper.realIndex + 1;

    if (cursor.classList.contains('is-prev')) {
        const prevIndex = current === 1 ? total : current - 1;
        label.textContent = `${prevIndex} / ${total}`;
    } else {
        const nextIndex = current === total ? 1 : current + 1;
        label.textContent = `${nextIndex} / ${total}`;
    }
  }

  /* Swiper marca la diapositiva activa con una clase, asi que vigilar las clases del slider
     sigue siendo suficiente para refrescar el contador al pasar de imagen. */
  function startObserver(swiper) {
    stopObserver();
    observer = new MutationObserver(() => updatePagination(swiper));
    observer.observe(swiper.el, {
      subtree: true,
      attributeFilter: ['class'],
    });
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function onEnter(e) {
    const wrapper = e.currentTarget;
    const swiper = getSwiper(wrapper);
    if (!swiper) return;

    ensureOnTop();
    updatePagination(swiper);
    cursor.style.opacity = '1';
    cursor.style.visibility = 'visible';
    startObserver(swiper);
  }

  function onLeave() {
    if (isClicking) return;
    cursor.style.opacity = '0';
    cursor.style.visibility = 'hidden';
    cursor.classList.remove('is-prev', 'is-next');
    stopObserver();
  }

  function onMove(e) {
    const wrapper = e.currentTarget;

    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';

    const rect = wrapper.getBoundingClientRect();
    const isLeft = (e.clientX - rect.left) < rect.width / 2;
    cursor.classList.toggle('is-prev', isLeft);
    cursor.classList.toggle('is-next', !isLeft);

    const swiper = getSwiper(wrapper);
    if (swiper) updatePagination(swiper);
  }

  function onClick(e) {
    const wrapper = e.currentTarget;
    const swiper = getSwiper(wrapper);
    if (!swiper) return;

    const rect = wrapper.getBoundingClientRect();
    const isLeft = (e.clientX - rect.left) < rect.width / 2;
    const activeClass = isLeft ? 'is-prev' : 'is-next';

    isClicking = true;

    /* El bucle se hace aqui y no con la opcion loop de Swiper, que con el fade se atasca:
       desde la ultima se vuelve a la primera y al reves, como hacia slick. */
    const total = swiper.slides.length;
    const actual = swiper.realIndex;

    if (isLeft) {
      swiper.slideTo(actual === 0 ? total - 1 : actual - 1);
    } else {
      swiper.slideTo(actual === total - 1 ? 0 : actual + 1);
    }

    cursor.classList.add(activeClass);
    setTimeout(() => { isClicking = false; }, 100);
  }

  function bindWrapper(wrapper) {
    if (wrapper.dataset.cursorBound === '1') return;   // no enganchar dos veces
    if (wrapper.closest(EXCLUDE)) return;              // ignora galería de arte
    wrapper.dataset.cursorBound = '1';

    wrapper.addEventListener('mouseenter', onEnter);
    wrapper.addEventListener('mouseleave', onLeave);
    wrapper.addEventListener('mousemove',  onMove);
    wrapper.addEventListener('click',      onClick);
  }

  function bindAll() {
    document.querySelectorAll(WRAPPER).forEach(bindWrapper);
  }

  // Enganche inicial + los wrappers que aparezcan por AJAX
  bindAll();
  new MutationObserver(bindAll).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/**
 * Tapar la galeria mientras WooCommerce recarga la variacion.
 *
 * El fade y la velocidad ya no se configuran aqui: los pone Swiper al inicializar. Lo que si
 * sigue haciendo falta es quitar wvg-ready mientras el formulario esta bloqueado, para que no
 * se vea el salto entre una variacion y la siguiente.
 */
(function () {
  const WRAPPER = '.woo-variation-gallery-wrapper';
  const EXCLUDE = '.is-art';

  const formObserver = new MutationObserver(() => {
    const hasOverlay = !!document.querySelector('form.cart .blockUI.blockOverlay');

    document.querySelectorAll(WRAPPER).forEach((el) => {
      if (el.closest(EXCLUDE)) return;
      el.classList.toggle('wvg-ready', !hasOverlay);
    });
  });

  /* Se vigila el body y no el formulario: el cambio de modelo por AJAX sustituye la ficha
     entera, y un observador colgado del formulario viejo se queda mirando un nodo ya
     desconectado, con la galeria tapada para siempre. */
  formObserver.observe(document.body, { childList: true, subtree: true });
})();

/**
 * Fancybox SOLO para la galería de arte (.is-art)
 * No toca el resto de sliders (.woo-variation-gallery-wrapper sin .is-art)
 */
(function () {
  const ART_WRAPPER = '.is-art .woo-variation-gallery-wrapper';
  const GALLERY_KEY  = 'art-product-gallery';

  function getFullImageUrl(img) {
    // data-large_image = resolución máxima real (la que interesa para el lightbox)
    return (
      img.getAttribute('data-large_image') ||
      img.getAttribute('data-src') ||
      img.closest('a')?.getAttribute('href') ||
      img.currentSrc ||
      img.src
    );
  }

  // Procesa UNA imagen. Se puede llamar muchas veces sin problema:
  // si ya está lista, no hace nada.
  function processImage(img) {
    if (img.dataset.fancyboxReady === '1') return;

    const fullUrl = getFullImageUrl(img);
    if (!fullUrl) return;

    let link = img.closest('a');

    if (!link) {
      link = document.createElement('a');
      img.parentNode.insertBefore(link, img);
      link.appendChild(img);
    }

    link.setAttribute('href', fullUrl);
    link.setAttribute('data-fancybox', GALLERY_KEY);
    link.setAttribute(
      'data-caption',
      img.getAttribute('data-caption') || img.getAttribute('alt') || ''
    );

    img.dataset.fancyboxReady = '1';
  }

  function scanWrapper(wrapper) {
    wrapper.querySelectorAll('.swiper-slide img').forEach(processImage);
  }

  /* Al cambiar de variacion WooCommerce sustituye el nodo entero de la galeria, asi que hay
     que volver a escanear cada vez que cambia el contenido del wrapper. */
  function watchWrapper(wrapper) {
    if (wrapper.dataset.fancyboxObserving === '1') return;
    wrapper.dataset.fancyboxObserving = '1';

    scanWrapper(wrapper);

    const observer = new MutationObserver(() => scanWrapper(wrapper));
    observer.observe(wrapper, { childList: true, subtree: true });
  }

  function initArtFancybox() {
    document.querySelectorAll(ART_WRAPPER).forEach(watchWrapper);
    // No hace falta llamar a Fancybox.bind() aquí:
    // el bind global de fancybox.js ('[data-fancybox]') usa delegación de
    // eventos y detecta estos enlaces automáticamente en cuanto existen.
  }

  // Intento inicial (por si el slider ya está pintado)
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initArtFancybox, 400);
  });

  // Detecta wrappers de arte que aparezcan más tarde en la página
  const bodyObserver = new MutationObserver(initArtFancybox);
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
